<script setup>
import columns from '../../../config/reports/columnsClickouts';
</script>

<template>
  <table-base
    has-phone-layout
    :columns="columns"
    class="reports-clickouts-table"
    :items="items"
    :is-loading="isLoading"
    :has-no-footer="true"
    :pagination="{}"
    has-custom-items-template
  >
    <template v-slot:item-cell="scope">
      <template v-if="scope.cell.column.value === 'commission'">
        {{ separateEvery3Digits(Number.parseFloat(scope.cell.item.commission).toFixed(2)) }}
      </template>

      <template v-else-if="scope.cell.column.value === 'clicks'">
        {{ separateEvery3Digits(scope.cell.item.clicks) }}
      </template>

      <template v-else>
        {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
      </template>
    </template>
  </table-base>
</template>

<script>
import {extractNestedProp, separateEvery3Digits} from "@/utils";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    displayColumnValue(item, columnValue) {
      return extractNestedProp(item, columnValue);
    },
  }
}
</script>

<style scoped lang="scss">
.reports-table{}

.reports-table__commission {
  white-space: nowrap;

  span {
    font-weight: 700;
    font-size: 12px;
  }
}
</style>
